<script>
import { mapActions } from 'vuex'
import Layout from "../../../layouts/main";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../../app.config";

/**
 * Advanced Table component
 */
export default {
  page: {
    title: "Admin User Management",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      tableData: [],
      title: "Admin User Management",
      items: [
        {
          text: "Users",
          href: "/",
        },
        {
          text: "List",
          active: true,
        },
      ],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      params: {
        limit: 10,
        offset: 0,
        search: '',
        role: 1
      },
      fields: [
        {
          key: "username",
          sortable: false,
        },
        {
          key: "email",
          sortable: false,
        },
        {
          key: "area",
          sortable: false,
        },
        {
          key: "status",
          sortable: false,
        },
        "action",
      ],
      formError: '',
      isFormError: false,
      textAlert: '',
      showAlert: false,
      showalertbtn: true,
      showInfo: false,
      textInfo: '',
      showReset: false,
      emailReset: '',
      showDelete: false,
      usernameDelete: ''
    };
  },
  watch: {
    perPage: {
      handler: function (val, oldVal) {
        if (val !== oldVal) {
          this.params.limit = val;
          this.rendering();
        }
      }
    },
    currentPage: {
      handler: function (val, oldVal) {
        if (val !== oldVal) {
          this.params.offset = parseInt(this.perPage)*(parseInt(val)-1);
          this.rendering();
        }
      }
    },
    filter: {
      handler: function (val, oldVal) {
        if(val !== oldVal) {
          this.params.search = val;
          this.rendering();
        }
      }
    },
    isFormError: {
      handler: function (val, oldVal) {
        if (!val) {
          this.formError = '';
        }
      }
    },
    showAlert: {
      handler: function (val, oldVal) {
        if (!val) {
          this.textAlert = '';
          this.showalertbtn = true;
        }
      }
    },
    showInfo: {
      handler: function (val, oldVal) {
        if (!val) {
          this.textInfo = '';
        }
      }
    },
    showReset: {
      handler: function (val, oldVal) {
        if (!val) {
          this.emailReset = '';
        }
      }
    },
    showDelete: {
      handler: function (val, oldVal) {
        if (!val) {
          this.usernameDelete = '';
        }
      }
    },
  },
  mounted() {
    this.getAccess();
    var userdata = JSON.parse(localStorage.getItem('user'));
    var afterLogin = this.$route.params.login ? true : false;
    if (userdata && afterLogin) {
      if (userdata.expired.status) {
        this.textAlert = 'Your current password will be expired in: ' + userdata.expired.detail.days +
        ' day (' + userdata.expired.detail.date + '). Please change the password before the expiration date.';
        this.showAlert = true;
      }
    }
  },
  created() {
    let userdata = JSON.parse(localStorage.getItem('user'));
    if (userdata.userdata.role.name == 'superadmin') { this.rendering(); }
  },
  methods: {
    ...mapActions('users', ['allUser', 'removeUser', 'resetPass']),
    getAccess() {
      let userdata = JSON.parse(localStorage.getItem('user'));
      if (userdata.userdata.role.name != 'superadmin') { this.$router.push({ name: 'error-404' }); }
    },
    rendering() {
      this.tableData = []
      this.allUser(this.params).then((response) => {
        this.tableData = response.data.length > 0 ? response.data : [];
        this.totalRows = response.detail.total;
      }).catch((error) => {
        this.formError = error;
        this.isFormError = true;
      })
    },
    removeData(username) {
      this.usernameDelete = username;
      this.showDelete = true;
    },
    removeAction() {
      var username = this.usernameDelete;
      this.showDelete = false;
      this.removeUser({username: username}).then((response) => {
        this.rendering();
      }).catch((error) => {
        this.formError = error;
        this.isFormError = true;
      })
    },
    resetPassButton(email) {
      this.emailReset = email;
      this.showReset = true;
    },
    resetAction() {
      var email = this.emailReset;
      this.showReset = false;
      this.isFormError = false;
      this.showInfo = true; this.textInfo = 'Loading...';
      this.resetPass(email).then((response) => {
        this.showInfo = false;
        this.textAlert = "Please, check your email.";
        this.showAlert = true;
      }).catch((error) => {
        this.showInfo = false;
        this.formError = error;
        this.isFormError = true;
      });
    },
    showPassword(pass) {
      this.textAlert = pass;
      this.showalertbtn = false;
      this.showAlert = true;
    }
  },
  middleware: "router-auth",
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-alert
              v-model="showInfo"
              class="mt-3"
              variant="info"
              dismissible
              >{{ textInfo }}</b-alert
            >
            <b-alert
              variant="danger"
              class="mt-3"
              v-model="isFormError"
              show="5"
              dismissible
              >{{ formError }}</b-alert
            >
            <div class="row mb-2">
              <div class="col-sm-6">
                <router-link
                  :to="{ name: 'create-admin'}"
                  class="btn btn-info mb-2"
                  ><i class="mdi mdi-plus-circle mr-1"></i> Add
                  Admin</router-link
                >
              </div>
            </div>
            <div class="row mb-md-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                      class="ml-2"
                    ></b-form-select>
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                thead-tr-class="bg-light"
                :items="tableData"
                :fields="fields"
                responsive="sm"
              >
                <template v-slot:cell(status)="data">
                  <span
                    class="badge"
                    :class="{
                      'badge-soft-success': data.item.isActive === true,
                      'badge-soft-danger': data.item.isActive === false,
                    }"
                  >
                    {{ data.item.isActive?'Active':'Inactive' }}</span
                  >
                </template>

                <template v-slot:cell(action)="data">
                  <ul class="list-inline table-action m-0">
                    <li class="list-inline-item">
                      <a href="javascript:void(0);" @click="resetPassButton(data.item.email)" class="action-icon">
                        <i class="mdi mdi-refresh"></i>
                      </a>
                    </li>
                    <li class="list-inline-item">
                      <router-link :to="{ name: 'update-admin', query: { username: data.item.username }}" class="action-icon">
                        <i class="mdi mdi-square-edit-outline"></i
                      ></router-link>
                    </li>
                    <li class="list-inline-item">
                      <a href="javascript:void(0);" @click="removeData(data.item.username)" class="action-icon">
                        <i class="mdi mdi-delete"></i
                      ></a>
                    </li>
                  </ul>
                </template>
                
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

            <b-modal
              id="info-alert-modal"
              body-class="p-4"
              hide-header
              hide-footer
              size="sm"
              v-model="showAlert"
            >
              <div class="text-center">
                <i v-if="showalertbtn" class="bx bxs-info-circle h1 text-info"></i>
                <h4 v-if="showalertbtn" class="mt-2">Info</h4>
                <p class="mt-3">{{textAlert}}</p>
                <button
                  type="button"
                  class="btn btn-info my-2"
                  v-on:click="showAlert=false"
                >OK</button>
              </div>
            </b-modal>

            <b-modal
              id="info-warning-modal"
              body-class="p-4"
              hide-header
              hide-footer
              size="sm"
              v-model="showReset"
            >
              <div class="text-center">
                <p class="mt-3">Reset password this account ?</p>
                <button
                  type="button"
                  class="btn btn-info my-2 mr-2"
                  v-on:click="resetAction()"
                >OK</button>
                <button
                  type="button"
                  class="btn btn-secondary my-2"
                  v-on:click="showReset=false"
                >Cancel</button>
              </div>
            </b-modal>

            <b-modal
              id="info-danger-modal"
              body-class="p-4"
              hide-header
              hide-footer
              size="sm"
              v-model="showDelete"
            >
              <div class="text-center">
                <p class="mt-3">Remove this account ?</p>
                <button
                  type="button"
                  class="btn btn-warning my-2 mr-2"
                  v-on:click="removeAction()"
                >OK</button>
                <button
                  type="button"
                  class="btn btn-secondary my-2"
                  v-on:click="showDelete=false"
                >Cancel</button>
              </div>
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
